import { EmployeeZoneAlias } from '../../types';
import EmployeeDashboardItem from '../EmployeeDashboardItem/EmployeeDashboardItem';
import { DashboardSectionConfig } from 'domain/shared/core/dashboard';
import { DELEGATED_EMPLOYEE_ZONES, DELEGATED_EMPLOYEE_ZONES_ALIASES } from '../../constants';
import { DashboardZone } from 'framework/ui/dashboard';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useTheme } from '@mui/material/styles';

const EMPLOYEE_ZONE_TEXT = {
  [DELEGATED_EMPLOYEE_ZONES_ALIASES.DELEGATED]: 'Requires action for managed issues',
  [DELEGATED_EMPLOYEE_ZONES_ALIASES.SAFE]: 'No challenges',
  [DELEGATED_EMPLOYEE_ZONES_ALIASES.MONITORING]: 'Not critical challenges',
  [DELEGATED_EMPLOYEE_ZONES_ALIASES.CRITICAL]: 'Requires immediate action',
  [DELEGATED_EMPLOYEE_ZONES_ALIASES.ESCALATION]: 'Emergency intervention is required',
};

type EmployeeStageContentProps = {
  zone: EmployeeZoneAlias;
  sectionsConfig?: DashboardSectionConfig;
};

const EmployeesDashboardZone = ({ zone }: EmployeeStageContentProps) => {
  const theme = useTheme();

  const employeeZoneAccentColor = {
    [DELEGATED_EMPLOYEE_ZONES_ALIASES.SAFE]: theme.palette.success.main,
    [DELEGATED_EMPLOYEE_ZONES_ALIASES.MONITORING]: theme.palette.warning.main,
    [DELEGATED_EMPLOYEE_ZONES_ALIASES.CRITICAL]: theme.palette.error.main,
    [DELEGATED_EMPLOYEE_ZONES_ALIASES.ESCALATION]: theme.palette.error.dark,
    [DELEGATED_EMPLOYEE_ZONES_ALIASES.DELEGATED]: theme.palette.text.secondary,
  };

  const zoneConfig = {
    key: zone,
    title: DELEGATED_EMPLOYEE_ZONES[zone],
    description: EMPLOYEE_ZONE_TEXT[zone],
    descriptionIcon:
      zone === DELEGATED_EMPLOYEE_ZONES_ALIASES.ESCALATION ? (
        <ErrorOutlineIcon color="error.dark" sx={{ fontSize: 18, mr: 0.75 }} />
      ) : null,
    accentColor: employeeZoneAccentColor[zone],
    filterFn: (item: any) => item.retentionRiskPriority === zone,
  };

  return (
    <DashboardZone
      zone={zoneConfig}
      renderItem={(employee: any, update) => (
        <EmployeeDashboardItem employee={employee} update={update} currentZone={zone} />
      )}
      sx={{
        pt: '10px',
      }}
    />
  );
};

export default EmployeesDashboardZone;
